import { Recipient } from './recipient';

export class Message {
    messageSubject: string;
    messageText: string;
    messageMaps: any[];
    recipients: Recipient[];
}
